import React, { useEffect, useState } from "react";
import Contenido from "./components/Contenido";
import { getEstadoAutorizantes, getSolicitudes } from "../../services/mis-solicitudes/solicitudes";
import { solicitudesAdapter } from "../../services/adapters/solicitudes.adapter";
import { IconButton } from "@artprov/design-system";

export default function MisSolicitudes() {
  const [misSolicitudes, setMisSolicitudes] = useState([]);
  const [showModalAut, setShowModalAut] = useState(false)
  const [autorizantes, setAutorizantes] = useState([])
  const [showModalComentario, setShowModalComentario] = useState(false)
  const [observacion, setObservacion] = useState({})

  async function getMisSolicitudes() {
    return await getSolicitudes();
  }

  function solicitudesAdaptedToDom(rendiciones) {
    const rendicionesAdaptedToDom = rendiciones.map((item, i) => { //Por cada solicitud agregamos el botón para abrir el modal de autorizantes

      const botonComentario = <IconButton key={i + i + item.nro} icon="mark_unread_chat_alt" className="gap-0 m-0 p-0 w-full" onClick={() => {
        setShowModalComentario(true)
        setObservacion({
          mensaje: item.observaciones,
          titulo: `Mensaje de [${item.autorizanteModif}]`,
          subtitulo: `Comentarios de la solicitud N°${removerCerosIniciales(item.nro)}`
        })
      }} />
      const botonAutorizantes = <IconButton key={i + item.nro} icon="visibility" className="gap-0 m-0 p-0 w-full"
        onClick={
          async () => {
            const { traza } = await getEstadoAutorizantes(item.nro)
            setAutorizantes(traza.length ? traza : [traza])
            setShowModalAut(true)
          }
        } />
      return { ...item, autorizante: botonAutorizantes, comentario: (item.observaciones !== "-" && item.estado === "Rechazada") ? botonComentario : <></> };
    });

    return rendicionesAdaptedToDom;
  };

  const onCloseModalAutorizantes = () => {
    setShowModalAut(false)
    setAutorizantes([])
  }

  const onCloseModalObervacion = () => {
    setShowModalComentario(false)
    setObservacion({})
  }

  useEffect(() => {
    const init = async () => {
      let misSolicitudesData = await getMisSolicitudes();
      let misSolicitudesDataAdapted =
        misSolicitudesData?.data.length > 0 ? solicitudesAdapter(misSolicitudesData) : [];
      const solicitudesTabla = solicitudesAdaptedToDom(misSolicitudesDataAdapted.rows)
      setMisSolicitudes(solicitudesTabla);
    };
    init();
  }, []);

  return misSolicitudes?.length > 0 ? (
    <Contenido
      data={misSolicitudes}
      openModalAutorizantes={showModalAut}
      onCloseModalAutorizaciones={onCloseModalAutorizantes}
      autorizantes={autorizantes}
      dataObservacion={observacion}
      openModalObservacion={showModalComentario}
      closeModalObservacion={onCloseModalObervacion}
    />
  ) : <Contenido data={[]} openModalAutorizantes={showModalAut} autorizantes={autorizantes} onCloseModal={() => setShowModalAut(false)} />;
}

function removerCerosIniciales(str) {
  return str.replace(/^0+/, '');
}
